export default __webpack_public_path__ + "static/media/male-flatter.caf5b9fb.webp";